import {useQuery, useMutation} from '@/hooks/useApi'
import * as api from '@/services/api'
import type {AiProcessingStats, AiProcessingSummary} from '@/services/api/types/ai-processing'

export function useAiProcessingStats() {
  return useQuery<AiProcessingStats>({
    queryKey: ['ai-processing-stats'],
    queryFn: async () => {
      const res = await api.aiProcessing.getAiProcessingStats()
      return res.data.data
    },
    refetchInterval: (data) => (data?.processing ?? 0) > 0 ? 10_000 : false,
  })
}

export function useDismissAiProcessingItem() {
  return useMutation({
    mutationFn: (id: string) => api.aiProcessing.dismissAiProcessingItem(id),
  })
}

export function useAiProcessingWidget() {
  const {data, isLoading, isError} = useAiProcessingStats()
  const isVisible = !isLoading && !isError
  const isProcessing = !!data && data.processing > 0
  return {isVisible, statsData: data, isProcessing}
}

export function useAiProcessingSummary(sortByStatus?: string) {
  return useQuery<AiProcessingSummary>({
    queryKey: ['ai-processing-summary', sortByStatus],
    queryFn: async () => {
      const res = await api.aiProcessing.getAiProcessingStatusSummary(sortByStatus)
      return res.data.data
    },
    refetchInterval: (data) => data?.items.some(item => item.status === 'PROCESSING') ? 10_000 : false,
  })
}
